// lodash components
import isEmpty from 'lodash/isEmpty'
import join from 'lodash/join'
import padEnd from 'lodash/padEnd'
import replace from 'lodash/replace'
import split from 'lodash/split'

const territory = process.env.TERRITORY
let moneyFormatter = new Intl.NumberFormat('en-US')
let decimalSeparator = '.'

function formatCurrency(value, allowZero = false) {
    if (value || allowZero) {
        let valueArray = value.toString().split(' - '),
            values = null
        valueArray.forEach((values, index) => {
            values = replace(values, /[^0-9.]/g, '')
            values = moneyFormatter.format(values)
            values = padDecimal(values)
            if (index > 0) {
                value += '-' + currency(values)
            } else {
                value = currency(values)
            }
        })
    }
    return value
}

function currency(value) {
    let currency

    switch (territory) {
        case 'usa':
        case 'aus':
            currency = '$'
            break

        default:
            currency = '£'
            break
    }

    return `${currency}${value}`
}

function padDecimal(value) {
    value = split(value, decimalSeparator)

    if (value[1]) {
        value[1] = padEnd(value[1], 2, 0)
    }

    return join(value, decimalSeparator)
}

function formatPercentage(value) {
    if (isEmpty(value)) {
        return
    }

    if (decimalSeparator !== '.') {
        return value.split('.').join(decimalSeparator)
    }

    if (value.includes('%') && value === '0.00%') {
        return '0%'
    }

    return value.includes('%') ? value : value + '%'
}

export { moneyFormatter, currency, formatCurrency, formatPercentage }
